import {setCookie, getCookie} from 'methods/utils';

function ListViewedHotels() {
    if (window.listOfViewedHotels) {
        return window.listOfViewedHotels;
    }
    window.listOfViewedHotels = this;

    this._cookieName = 'list_of_viewed_hotels';

    document.addEventListener('click', this._track.bind(this));
}

ListViewedHotels.prototype._track = function(event) {
    const $link = event.target.closest('a');
    const $tracked = $link?.closest('.js-view-tracked[data-hotel-id]');

    if (!$tracked) return;

    $tracked.classList.add('in-viewed-list');

    this.append(Number($tracked.dataset.hotelId));
};

ListViewedHotels.prototype.set = function(ids) {
    setCookie(this._cookieName, JSON.stringify(ids), 30);

    this.checkAll();
}

ListViewedHotels.prototype.get = function() {
    return JSON.parse(getCookie(this._cookieName) || '[]');
}

ListViewedHotels.prototype.append = function(id) {
    if (typeof id !== 'number' || this.has(id)) return;

    this.set([...this.get(), id]);
};


ListViewedHotels.prototype.has = function(id) {
    return this.get().includes(id);
};

ListViewedHotels.prototype.remove = function(id) {
    this.set(this.get().filter((hotelId) => hotelId !== id));
};

ListViewedHotels.prototype.clear = function() {
    this.set([]);
};

ListViewedHotels.prototype.checkAll = function() {
    const $trackedAll = document.querySelectorAll('.js-view-tracked[data-hotel-id]');

    $trackedAll.forEach(($tracked) => {
        $tracked.classList.toggle('in-viewed-list', 
            this.has(Number($tracked.dataset.hotelId))
        );
    });
};

export default ListViewedHotels;
